module.exports = __webpack_public_path__ + "static/media/infoicon.1352a0ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/infoicon.svg
// module id = 1723
// module chunks = 0